import React, { FC, ReactNode } from 'react';
import { useMediaQuery } from 'react-responsive';
import styled, { css } from 'styled-components';

import theme from '~/constants/theme';

interface Props {
  left?: ReactNode;
  content: ReactNode;
  right?: ReactNode;
  className?: string;
}

const WizardContent: FC<Props> = (props) => {
  const { left, content, right, className } = props;
  const isTablet = useMediaQuery({ maxWidth: theme.breakpoints.lg });

  return (
    <Container left={left} right={right} className={className}>
      {left && <div className="WizardContent-Corner WizardContent-CornerLeft">{left}</div>}
      <div className="WizardContent-Content">
        {content}
        {isTablet && right && <div className="WizardContent-BottomButton">{right}</div>}
      </div>
      {!isTablet && right && <div className="WizardContent-Corner WizardContent-CornerRight">{right}</div>}
    </Container>
  );
};

type WizardContentStyleProps = { left?: ReactNode; right?: ReactNode };

const Container = styled.div<WizardContentStyleProps>`
  display: flex;
  flex: 1;
  justify-content: space-between;

  .WizardContent-Corner {
    position: sticky;
    top: 55px;
    height: calc(100vh - 192px);
    display: flex;
    flex-direction: column;
    flex: 1;
    padding: 0 55px 0;
    max-width: 357px;
  }
  .WizardContent-CornerRight {
    justify-content: flex-end;
  }
  .WizardContent-Content {
    display: flex;
    flex-direction: column;
    ${({ left, right }) =>
      left && right
        ? css`
            width: 820px;
          `
        : undefined}
  }

  .WizardContent-BottomButton {
    margin-top: 28px;
    button {
      width: unset;
      min-width: calc(50% - 10px);
    }
  }

  @media (max-width: ${theme.breakpoints.xl + 32}px) {
    .WizardContent-Content {
      ${({ left, right }) =>
        left && right
          ? css`
              width: 50vw;
            `
          : undefined}
    }
  }

  @media (max-width: ${theme.breakpoints.lg}px) {
    .WizardContent-Content {
      ${({ left, right }) =>
        left && right
          ? css`
              width: calc(70vw - 32px);
            `
          : undefined}
    }
    .WizardContent-CornerLeft {
      width: calc(30vw - 32px);
    }
    .WizardContent-CornerRight {
      display: none;
    }
  }
  @media (max-width: ${theme.breakpoints.md}px) {
    padding: 0;
    .WizardContent-CornerLeft {
      display: none;
    }
    .WizardContent-Content {
      width: 100%;
    }
    .WizardContent-BottomButton {
      button {
        width: 100%;
      }
    }
  }
  @media (max-width: ${theme.breakpoints.sm}px) {
    .WizardContent-BottomButton {
      margin-top: 0;
    }
  }
  .loading_state {
    font-size: 30vh;
  }
`;

export default WizardContent;
